import AlertDialog from 'components/Dialog/AlertDialog'
import { useCallback, useEffect, useState } from 'react'
import licenseExpiredEventBus from './licenseExpiredEventBus'

function LicenseExpiredDialog() {
    const [open, setOpen] = useState(false)

    const onClose = useCallback(() => {
        window.location.reload()
        setOpen(false)
    }, [])

    useEffect(() => {
        const subscription = licenseExpiredEventBus.subscribe(() => {
            setOpen(true)
        })

        return () => {
            subscription.unsubscribe()
        }
    }, [])

    return (
        <AlertDialog open={open} onClose={onClose}>
            We regret to inform you that your current license has expired. In
            order to resume your session, we kindly request you to extend your
            license.
        </AlertDialog>
    )
}

export default LicenseExpiredDialog
